import { defineStore } from "pinia";
import { ref } from "vue";

export const useHelpChatStore = defineStore("helpChat", () => {
  const opened = ref(false);
  const message = ref("");

  function openHelpChat(defaultMessage = "") {
    message.value = defaultMessage;
    opened.value = true;
  }

  return { opened, message, openHelpChat };
});
